<template>
  <div class="footer">
    <div class="footer_detail">
      <div class="footer_body">
        <div class="footer_option">
          <h4>关于我们</h4>
          <ul>
            <li><a href="tel:18245002033">客服电话: 182-4500-2033</a></li>
            <li><a href="javascript:void(0)">企业微信: xwt-education1</a></li>
            <li><a href="javascript:void(0)">企业名字:Gamain Group </a></li>
            <li><a href="mailto:jingpeieducation@163.com" target="_blank">企业邮箱:jingpeieducation@163.com </a></li>
          </ul>
        </div>
        <div class="footer_option classIntro">
          <h4>课程介绍</h4>
          <ul>
            <li><a href="javascript:void(0)">澳洲CPA课程</a><!-- /CPA --></li>
            <li><a href="javascript:void(0)">CFA Program课程</a><!-- /CFA --></li>
            <li><a href="javascript:void(0)">会计实战课程</a><!-- /accounting --></li>
            <li><a href="javascript:void(0)">PTE语言培训</a><!-- /PTE --></li>
            <li><a href="javascript:void(0)">雅思托福保过班</a><!-- /IELTS --></li>
            <li><a href="javascript:void(0)">藤校/G5直推班</a><!-- /G5 --></li>
          </ul>
        </div>
        <div class="footer_option schoolIntro">
          <h4>精培校区</h4>
          <ul>
            <li><a href="javascript:void(0)">澳大利亚 · 悉尼大学</a><!-- /macquarie --></li>
            <li><a href="javascript:void(0)">澳大利亚 · 麦考瑞大学</a><!-- /monash --></li>
            <li><a href="javascript:void(0)">澳大利亚 · 新南威尔士大学</a><!-- /UNSW --></li>
            <li><a href="javascript:void(0)">澳大利亚 · 莫纳什大学</a><!-- /manchester --></li>
            <li><a href="javascript:void(0)">加拿大 · 达尔豪斯大学</a><!-- /kingsLondon --></li>
            <li><a href="javascript:void(0)">加拿大 · 曼尼托巴大学</a><!-- /holloway --></li>
            <li><a href="javascript:void(0)">英国· 曼彻斯特大学</a><!-- /kingsLondon --></li>
            <li><a href="javascript:void(0)">英国 · 国王大学</a><!-- /holloway --></li>
          </ul>
        </div>
        <div class="footer_option">
          <h4>微信咨询</h4>
          <ul>
            <li><a href="http://localhost:8081/">
              <img class="wechat" :src="require('../assets/wechatPic.jpg')" />
            </a></li>
          </ul>
        </div>
      </div>
      <div class="copyright">
        Copyright © 2021 www.gamainedu.com/ All Rights Reserved
<!--        <span>苏ICP备000000000号</span>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    list-style-type:none;
    font-style: normal;}
  .footer {
    background-color: #32333b;
    color: #a8aaba;
    width: 100%;
    text-align: center;
  }
  .footer a{
    color: #a8aaba;
  }
  .footer_detail{
    display: inline-block;
    padding: 0 auto;
  }
  .footer .footer_option {
    width: 290px;
    float: left;
    padding: 40px 0 20px 0px;
    text-align: left;
  }
  .footer .classIntro{
    width: 250px;
    padding-left: 40px;
  }
  .footer .schoolIntro{
    width: 270px;
    padding-left: 20px;
  }
  .footer .logo{
    width: 100px;
  }
  .footer .footer_option h4{
    font-size: 20px;
    margin-bottom: 20px;
  }
  .footer .footer_option ul li{
    line-height: 30px;
  }
  .footer .wechat{
    width: 200px;
  }
  .copyright {
    clear: both;
    padding: 20px 0 20px 0;
  }
  @media screen and (max-width:700px){
    .footer_body{
      width: 100%;
      text-align: center;
    }
    .footer .footer_option{
      text-align: center;
      margin: 0 auto 0 auto;
      float: none;
    }
    .footer .classIntro,.schoolIntro{
      padding-left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue